<form [formGroup]="agregarFormCondGrupoCliente">
  <div class="row">
    <div class="col-lg-12">
      <app-lfsa-input [control]="this.agregarFormCondGrupoCliente.get('id_promo')" [id]="'id_promo'"
        [isReadOnly]="true" [label]="'ID PROMO'" formControlName="id_promo" type="text"></app-lfsa-input>
    </div>
    <div class="col-lg-12 mb-5">
      <label for="id_grupo_cliente">Grupo Cliente</label>
      <select class="form-control" formControlName="id_grupo_cliente" id="id_grupo_cliente">
        <option value="">Seleccione una opción</option>
        <option *ngFor="let data of cmbGrupoCliente" [value]="data.idGrupoCliente">{{ data.idGrupoCliente + ' - ' + data.dscaGrupoCliente }}</option>
      </select>
    </div>
  </div>
  <app-lfsa-botones-formulario (devolverAccion)="accionesCondGrupoCliente( $event )"
    [formularioValido]="(!agregarFormCondGrupoCliente.invalid) ? false : true"
    [textBoton]="'Guardar'" class="row">
  </app-lfsa-botones-formulario>
</form>
